<template>
    <v-dialog v-model="dialog" persistent max-width="600px">
        <!--        <template v-slot:activator="{ on }">-->
        <!--            <v-btn-->
        <!--                    v-on="on"-->
        <!--                    icon-->
        <!--            >-->
        <!--                <v-icon v-if="blob.id === undefined">mdi-plus</v-icon>-->
        <!--                <v-icon v-else>mdi-cog</v-icon>-->
        <!--            </v-btn>-->
        <!--        </template>-->

        <template v-slot:activator="{ on: dialog }">
            <v-tooltip
                    top
                    :open-delay="tooltipDelay"
            >
                <template v-slot:activator="{ on: tooltip }">
                    <v-btn
                            v-on="{ ...tooltip, ...dialog}"
                            icon
                    >
                        <v-icon v-if="blob.id === undefined">mdi-plus</v-icon>
                        <v-icon v-else>mdi-cog</v-icon>
                    </v-btn>
                </template>
                <span v-if="blob.id === undefined">{{ $t('controls.tooltip.add_blob') }}</span>
                <span v-else>{{ $t('controls.tooltip.edit_blob') }}</span>
            </v-tooltip>
        </template>

        <BlobForm
                v-if="dialog"
                :blob="blob"
                :cancel="true"
                @blobIsProcessed="done"
                @blobIsCanceled="close"
        ></BlobForm>
    </v-dialog>
</template>

<script>
  import BlobForm from './BlobForm'
  import { mapGetters } from 'vuex'
  import { settings } from '../../settings/settings.js'

  export default {
    name: 'BlobFormDialog',
    components: { BlobForm },
    props: {
      blob: {
        type: Object,
        default () {
          return {
            radar_id: this.radarId
          }
        }
      }
    },

    data: () => ({
      ...settings,
      dialog: false
    }),

    computed: {
      ...mapGetters({
        radarId: 'radars/getCurrentRadarId',
      })
    },
    methods: {
      done () {
        this.dialog = false
      },
      close () {
        this.dialog = false
      }
    }
  }
</script>
